import * as React from 'react';

function SvgSwitchTeam(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14.187} height={16.003} {...props}>
      <defs>
        <style>{'.switch_team_svg__cls-1{fill:#008afd}'}</style>
      </defs>
      <g id="switch_team_svg__switch_team" transform="translate(-29.049)">
        <path
          id="switch_team_svg__Path_261"
          data-name="Path 261"
          className="switch_team_svg__cls-1"
          d="M83.714 2.495L80.939.156a.667.667 0 00-.857 1.021l1.376 1.169h-6.59a3.789 3.789 0 00-3.784 3.784v1.2a.666.666 0 001.333 0V6.119a2.455 2.455 0 012.451-2.451h6.594l-1.376 1.169a.667.667 0 00.857 1.021l2.775-2.338a.667.667 0 00.082-.939.681.681 0 00-.082-.082z"
          transform="translate(-40.72)"
        />
        <path
          id="switch_team_svg__Path_262"
          data-name="Path 262"
          className="switch_team_svg__cls-1"
          d="M41.237 255.877a.667.667 0 00-.666.666v1.208a2.455 2.455 0 01-2.451 2.451h-6.595l1.376-1.169a.667.667 0 10-.645-1.167.659.659 0 00-.193.161l-2.775 2.338a.667.667 0 00-.082.939.68.68 0 00.082.082l2.775 2.338a.667.667 0 00.857-1.021l-1.376-1.169h6.575a3.789 3.789 0 003.784-3.784v-1.208a.666.666 0 00-.666-.665z"
          transform="translate(0 -247.879)"
        />
      </g>
    </svg>
  );
}

export default SvgSwitchTeam;
